import { render, staticRenderFns } from "./DeleteServerModal.vue?vue&type=template&id=13e43f68&"
import script from "./DeleteServerModal.vue?vue&type=script&lang=js&"
export * from "./DeleteServerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports